import axios from '@/axios/api.request'

export const save = (form) => axios.request({
    url: '/returned/money/save',
    data: form,
    method: 'post'
  })

  export const applyBack = (form) => axios.request({
    url: '/returned/money/back',
    data: form,
    method: 'post'
  })